<script setup lang="ts">
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'

interface GwTableNoteProps {
  value: string
  isMenuOpen?: boolean
}

defineProps<GwTableNoteProps>()
</script>

<template>
  <GwTooltipNew
    :disabled="!value"
    :placement="isMenuOpen ? 'top-start' : 'bottom-start'"
  >
    <template #opener="{ listeners }">
      <i
        class="mdi mdi-18px mr-2"
        :class="`mdi-${value ? 'book-edit' : 'note-text-outline'}`"
        :style="{ color: value ? 'var(--clr-primary)' : 'var(--app-clr-grey-3)' }"
        v-on="listeners"
      />
    </template>
    <template #tooltip>
      <span
        class="d-block text-wrap"
        style="max-width: 20rem"
        v-html="value.replaceAll('\n', '<br />')"
      />
    </template>
  </GwTooltipNew>
</template>
